// 사이드바 '활동' 줄의 배지(3차 F58). 멘션을 받아도 판을 열어 보기 전엔 몰랐다.
//
// "어디까지 봤는가" 는 이 기기의 것이다 — 초안과 같은 자리(`localStorage`)에 사람마다 따로 둔다.
// 서버에 읽음 표시를 두지 않는 까닭: 활동은 채널 읽음과 달리 되짚는 목록이라, 본 적이 있다는 사실이
// 다른 기기의 배지를 끌 만큼 무겁지 않다. 기기마다 한 번 열면 꺼진다.

import type { Store } from './drafts.ts'

/** 새 활동 수를 세는 데 쓰는 창. 배지가 "20+" 를 넘길 일은 없다 — 그 뒤는 판에서 본다. */
export const NEWS_PEEK = 20

export function seen_key(me: number): string {
  return `maru.activity.seen.${me}`
}

/** '시작하기' 를 닫은 때(3차 F32). 같은 "여기까지 봤다" 모양이라 같은 읽고 쓰기를 쓴다. */
export function starter_key(me: number): string {
  return `maru.starter.closed.${me}`
}

/** 저장해 둔 "여기까지 봤다" 시각. 없거나 망가졌으면 `null`. */
export function read_seen(store: Store | undefined, key: string): string | null {
  try {
    const raw = store?.getItem(key) ?? null
    return raw !== null && !Number.isNaN(Date.parse(raw)) ? raw : null
  } catch {
    return null
  }
}

/** 저장은 던질 수 있다(비공개 모드·용량) — 배지는 편의지 약속이 아니므로 조용히 넘어간다. */
export function write_seen(store: Store | undefined, key: string, at: string): void {
  try {
    store?.setItem(key, at)
  } catch {
    // 이 판이 열려 있는 동안은 기억에 남는다.
  }
}

/** 가장 새 활동의 때. 없으면 `null`. */
export function newest(acts: readonly { at: string }[]): string | null {
  let best: string | null = null
  for (const a of acts) {
    if (best === null || Date.parse(a.at) > Date.parse(best)) best = a.at
  }
  return best
}

/**
 * `seen` 뒤에 온 활동 수. 한 번도 판을 연 적이 없으면(`null`) 0 이다 — 처음 켠 사람에게
 * 지난 활동 스무 개를 새것이라고 들이밀면 배지가 첫인상부터 거짓말이 된다.
 */
export function news_count(acts: readonly { at: string }[], seen: string | null): number {
  if (seen === null) return 0
  const cut = Date.parse(seen)
  return acts.filter((a) => Date.parse(a.at) > cut).length
}
